module.exports = __webpack_public_path__ + "img/w3_circle_close_light.c03ccaaf.png";